import { FC, memo, useMemo } from 'react'
import { Flex, Image, Text } from '@chakra-ui/react'

import { Citizen, CitizenFilter } from 'CitizenProfile/types'
import { capitalizeString, getFormattedAvatarUrl } from 'utils/transforms/string'
import getAssets from 'utils/assets/getAssets'
import { Avatar, TextWithCharacterLimit } from 'components'

type Props = {
  citizenFilter?: CitizenFilter
  citizen: Citizen
  citizenFields?: string[]
  isDefaultCitizenCard?: boolean
}

type EnabledFields = {
  [key: string]: boolean
}

const DefaultCitizenCard: FC<Props> = ({ citizenFilter, citizen, citizenFields = [] }) => {
  const citizenValues = useMemo(() => {
    return {
      id: citizen.id || citizen.unified_person_id,
      avatar: citizen.unified_person_id ? 'unified_person_main' : 'main',
      name: citizen.name || citizen.unified_person_name,
      sex: citizen.sex || citizen.unified_person_sex,
    }
  }, [citizen])

  const citizenFilterValues = useMemo(() => {
    return {
      name: citizenFilter?.name || citizenFilter?.unified_person_name,
    }
  }, [citizenFilter])

  const GenderImage = getAssets('Gender', citizenValues.sex as string)

  const enableFields: EnabledFields = useMemo(() => {
    return {
      id: citizenFields.includes('id'),
      avatar: citizenFields.includes('avatar'),
      name: citizenFields.includes('name'),
      sex: citizenFields.includes('sex'),
      sexIcon: citizenFields.includes('sex_icon'),
    }
  }, [citizenFields])

  function isFieldEnable(fieldName: string) {
    if (citizenFields.length == 0) return true
    return enableFields[fieldName]
  }

  return (
    <Flex align="center" gap={4}>
      {isFieldEnable('avatar') && <Avatar src={getFormattedAvatarUrl(citizen, citizenValues.avatar, { size: 'sm' })} />}

      <Flex direction="column" gap={1}>
        {isFieldEnable('name') && (
          <TextWithCharacterLimit hasHighlight highlightQuery={citizenFilterValues?.name as string} characterLimit={25}>
            {capitalizeString(citizenValues.name)}
          </TextWithCharacterLimit>
        )}

        {citizenValues.sex ? (
          <Flex align="center" gap={1}>
            {isFieldEnable('sexIcon') && <Image boxSize={4} src={GenderImage} alt="Icone do gênero do cidadão" />}
            {isFieldEnable('sex') && (
              <TextWithCharacterLimit variant="secondary">
                {citizenValues.sex === 'F' ? 'Feminino' : 'Masculino'}
              </TextWithCharacterLimit>
            )}
          </Flex>
        ) : (
          <Text variant="noData">Sem sexo</Text>
        )}
      </Flex>
    </Flex>
  )
}

export default memo(DefaultCitizenCard)
